import {
    faCircle,
    faHistory,
    faExchangeAlt,
    faUser,
    faUserTimes,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { useState, useRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
    ColumnDescription,
    TableChangeState,
} from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import TransferirAtendimento from "../../../Components/CardsPages/Atendimento/TransferirAtendimento";
import HistoricoCardPage from "../../../Components/CardsPages/Historico";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import { useUserInfor } from "../../../Context/User";
import {
    RemoverAtendimentoDoUsuarioController,
    ExcluirAtendimentoController,
} from "../../../Controllers/AtendimentoCliente/Atendimento/AtendimentoControllers";
import { AtenderAtendimentoController } from "../../../Controllers/Geral/Atendimentos/AtendimentosController";
import { ListarAtendimentosVistoriasController } from "../../../Controllers/VistoriaEntregaChaves/ListarAtendimentosVistorias/ListarAtendimentosVistoriasControllers";
import {
    IFiltroAtendimentosVistorias,
    IListarAtendimentosVistorias,
} from "../../../Interfaces/VistoriaEntregaChaves/ListarAtendimentosVistorias/ListarAtendimentosVistoriasInterfaces";
import { ACESSOS } from "../../../Routes/Acessos";
import StorageManagerCapys from "../../../Tools/Storage";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import { TModoGestaoAtendimento } from "../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { ListarProdutosPorEmpreendimentosController } from "../../../Controllers/Geral/Produtos/ProdutosControllers";

interface IPropsTableChange extends TableChangeState<any> {
    searchText: string;
}

export default function useAtendimentoVistoria(
    atendimento: TModoGestaoAtendimento
) {
    moment.locale("pt-br");

    const { PageFilter, filter, setPageFilter, setPage, setFilter } =
        usePaginationFilter<IFiltroAtendimentosVistorias>({
            page: 1,
        });

    const filterStorage = new StorageManagerCapys<IFiltroAtendimentosVistorias>(
        "FILTRO_ATENDIMENTO_VISTORIA"
    );

    const [idEmpreendimentoOption, setIdEmpreendimentoOption] = useState<Array<{
        label: string;
        value: number;
    }> | null>(null);

    const [idUnidadeOption, setIdUnidadeOption] = useState<Array<{
        label: string;
        value: number;
    }> | null>(null);

    const [valueEtapa, setValueEtapa] = useState<Array<{
        label: string;
        value: number;
    }> | null>(null);

    const [idTipoPeso, setIdTipoPeso] = useState<number[]>([]);

    const { UserInfor } = useUserInfor();

    const {
        value: atendimentosVistoria,
        loading: atendimentosVistoriaLoading,
        execute: updateAtendimentos,
    } = useAsyncEffect(
        () =>
            ListarAtendimentosVistoriasController(
                PageFilter.page,
                atendimento,
                {
                    ...PageFilter.filter,
                    ID_CASO:
                        PageFilter.filter?.ID_CASO?.toString() === ""
                            ? 0
                            : PageFilter.filter?.ID_CASO,

                    ID_USUARIO:
                        PageFilter.filter?.ID_USUARIO?.toString() === ""
                            ? 0
                            : PageFilter.filter?.ID_USUARIO,
                    ID_TIPO_CANAL_ATENDIMENTO:
                        PageFilter.filter?.ID_TIPO_CANAL_ATENDIMENTO?.toString() ===
                            ""
                            ? 0
                            : PageFilter.filter?.ID_TIPO_CANAL_ATENDIMENTO,
                    DS_STATUS_CASO: PageFilter.filter?.DS_STATUS_CASO?.toString() === undefined
                        ? "Aberto"
                        : PageFilter.filter?.DS_STATUS_CASO,
                }
            ),
        [PageFilter]
    );

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const totalPaginas = atendimentosVistoria?.PAGINAS || 1;

    const ultimaPesquisaRef = useRef("");
    const [pesquisaText, setPesquisaText] = useState("");
    // const [naoContem, setNaoContem] = useState<boolean>(true);

    function handleSearch(
        searchValue: string,
        newState: IPropsTableChange
        // contem: boolean
    ) {
        ultimaPesquisaRef.current = searchValue;

        setTimeout(() => {
            if (ultimaPesquisaRef.current === searchValue) {
                setFilter({
                    ...filter,
                    DS_PESQUISA: newState.searchText,
                    // FL_CONTEM: naoContem,
                });
                setPage(newState.page);
            }
        }, 1500);
    }

    //tabela
    const tableviewColumns: Array<
        ColumnDescription<IListarAtendimentosVistorias>
    > = [
            {
                dataField: "Ver Caso",
                text: "",
                isDummyField: true,
                formatter: (_, row) => {
                    const css = `
            .button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO} {
                color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO} !important;
                background-color: transparent;
                border-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
            }
            .button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO}:hover {
                color: #ffffff !important;
                background-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                border-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
            }
            .button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO} i {
                color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO} !important;
                background-color: transparent;
                border-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
            }
            .button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO}:hover i {
                color: #ffffff !important;
                background-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
                border-color: ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO};
            }
        `;
                    return (
                        <>
                            <style>{css}</style>
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="ver-atendimento-tooltip">
                                        Ver Atendimento
                                    </Tooltip>
                                }
                            >
                                <Link
                                    to={ACESSOS.ENTREGA_DE_CHAVES.TELAS.ATENDIMENTO.DS_LINK(
                                        row.ID_CASO
                                    )}
                                    className={`m-2 btn btn-icon ${row.PESO_ATENDIMENTO
                                        ?.HX_COR_PESO_ATENDIMENTO
                                        ? `button-Capys-${row.PESO_ATENDIMENTO?.ID_TIPO_PESO_ATENDIMENTO}`
                                        : "btn-outline-info"
                                        }`}
                                >
                                    <i
                                        className={`icon-xl ${row.PESO_ATENDIMENTO
                                            ?.DS_ICON_PESO_ATENDIMENTO
                                            ? `${row.PESO_ATENDIMENTO?.DS_ICON_PESO_ATENDIMENTO}`
                                            : "far fa-eye"
                                            } `}
                                    ></i>
                                </Link>
                            </OverlayTrigger>
                        </>
                    );
                },
                style: (cell, row) => {
                    if (row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO)
                        return {
                            borderLeft: `8px solid ${row.PESO_ATENDIMENTO?.HX_COR_PESO_ATENDIMENTO}`,
                        };
                    else return {};
                },
            },
            {
                dataField: "ID_CASO",
                text: "Solicitação",
            },
            {
                dataField: "DT_INICIO",
                text: "Data Abertura",
                formatter: (c) => new Date(c).toLocaleString(),
            },
            {
                dataField: "DS_CASO",
                text: "Descrição",
            },
            {
                dataField: "CONTA.DS_NOME_CLIENTE",
                text: "Cliente",
            },
            {
                dataField: "DS_CATEGORIA_ATENDIMENTO",
                text: "Categoria",
            },
            {
                dataField: "DS_ETAPA",
                text: "Etapa",
            },
            {
                dataField: "CONTATO.DS_NOME_CONTATO",
                text: "Contato",
            }, //alterado
            {
                dataField: "PRODUTO.DS_PRODUTO",
                text: "PRODUTO",
            },
            {
                dataField: "NR_DIAS_ATRASO",
                text: "SLA",
                formatter: (c) => (
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="ver-atendimento-tooltip">
                                {" "}
                                {c < 0 ? (
                                    <>{Math.abs(c)} Dias para Vencer</>
                                ) : (
                                    <>{c} Dias em Atraso SLA</>
                                )}
                            </Tooltip>
                        }
                    >
                        <FontAwesomeIcon
                            icon={faCircle}
                            size="1x"
                            className={`text-${c < 0 ? "success" : c === 0 ? "warning" : "danger"
                                }`}
                        />
                    </OverlayTrigger>
                ),
            },
            {
                dataField: "NR_DIAS_ATRASO_SLO",
                text: "SLO",
                formatter: (c) => (
                    <OverlayTrigger
                        overlay={
                            <Tooltip id="ver-atendimento-tooltip">
                                {" "}
                                {c < 0 ? (
                                    <>{Math.abs(c)} Dias para Vencer</>
                                ) : (
                                    <>{c} Dias em Atraso SLO</>
                                )}
                            </Tooltip>
                        }
                    >
                        <FontAwesomeIcon
                            icon={faCircle}
                            size="1x"
                            className={`text-${c < 0 ? "success" : c === 0 ? "warning" : "danger"
                                }`}
                        />
                    </OverlayTrigger>
                ),
            },
            {
                dataField: "",
                text: "",
                isDummyField: true,
                formatter: (_, row) => (
                    <div className="d-flex g-2 p-2">
                        <OverlayTrigger
                            overlay={
                                <Tooltip id="historico-tooltip">
                                    Histórico do Caso
                                </Tooltip>
                            }
                        >
                            <button
                                className="btn btn-icon btn-outline-primary"
                                onClick={() => {
                                    setModal({
                                        Component: () =>
                                            HistoricoCardPage({
                                                ID_CASO: row.ID_CASO,
                                            }),
                                        headerComponent: "Históricos",
                                        IconHeader: faHistory,
                                        collapseForm: true,
                                        size: "lg",
                                    });
                                    setShow(true);
                                }}
                            >
                                <FontAwesomeIcon icon={faHistory} />
                            </button>
                        </OverlayTrigger>
                        <div>
                            {UserInfor.FUNCOES.some(
                                (f) => f.NM_FUNCAO === "ADM_GERENCIAR_ATENDENTES"
                            ) && (
                                    <OverlayTrigger
                                        overlay={
                                            <Tooltip id="transferir-tooltip">
                                                Transferir Atendimento
                                            </Tooltip>
                                        }
                                    >
                                        <button
                                            className="btn btn-icon btn-outline-warning"
                                            onClick={() => {
                                                setModal({
                                                    Component: () => (
                                                        <TransferirAtendimento
                                                            ID_CASO={row.ID_CASO}
                                                            ID_TIPO_CASO={
                                                                ACESSOS.ATENDIMENTO
                                                                    .ID_MODULO
                                                            }
                                                            setShow={setShow}
                                                            update={() => {
                                                                updateAtendimentos(
                                                                    // filter.current,
                                                                    1,
                                                                    atendimento
                                                                );
                                                            }}
                                                            ID_USUARIO={row.ID_USUARIO}
                                                            ID_USUARIO_ACOMPANHAMENTO={
                                                                row.ID_USUARIO
                                                            }
                                                        />
                                                    ),
                                                    IconHeader: faExchangeAlt,
                                                    headerComponent:
                                                        "Transferir Atendimento",
                                                });
                                                setShow(true);
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faExchangeAlt} />
                                        </button>
                                    </OverlayTrigger>
                                )}
                        </div>
                        {!row.DS_NOME_USUARIO ? (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="atender-tooltip">Atender</Tooltip>
                                }
                            >
                                <button
                                    className="btn btn-icon btn-outline-success"
                                    onClick={() => {
                                        AtenderAtendimentoController(
                                            row.ID_CASO
                                        ).then(() =>
                                            updateAtendimentos(
                                                {
                                                    // ...filter.current,
                                                },
                                                1,
                                                atendimento
                                            )
                                        );
                                    }}
                                >
                                    <FontAwesomeIcon icon={faUser} />
                                </button>
                            </OverlayTrigger>
                        ) : (
                            <div>
                                {UserInfor.FUNCOES.some(
                                    (f) =>
                                        f.NM_FUNCAO === "ADM_GERENCIAR_ATENDENTES"
                                ) && (
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip id="remover-tooltip">
                                                    Remover Atendente
                                                </Tooltip>
                                            }
                                        >
                                            <button
                                                className="btn btn-icon btn-outline-danger"
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: `Deseja remover o vínculo de ${row.DS_NOME_USUARIO} a este atendimento?`,
                                                        icon: "info",
                                                        buttonsStyling: false,
                                                        confirmButtonText:
                                                            "<i class='la la-check'></i> Sim!",
                                                        showCancelButton: true,
                                                        cancelButtonText:
                                                            "<i class='la la-thumbs-down'></i> Não",
                                                        customClass: {
                                                            confirmButton:
                                                                "btn btn-outline-success",
                                                            cancelButton:
                                                                "btn btn-default",
                                                        },
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            RemoverAtendimentoDoUsuarioController(
                                                                row.ID_CASO
                                                            ).then(() => {
                                                                updateAtendimentos(
                                                                    // filter.current,
                                                                    1,
                                                                    atendimento
                                                                );
                                                            });
                                                        }
                                                    });
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faUserTimes} />
                                            </button>
                                        </OverlayTrigger>
                                    )}
                            </div>
                        )}
                        {UserInfor.FUNCOES.some(
                            (f) => f.NM_FUNCAO === "ADM_EXCLUIR_CASO"
                        ) && (
                                <OverlayTrigger
                                    overlay={
                                        <Tooltip id="historico-tooltip">
                                            Excluir Atendimento
                                        </Tooltip>
                                    }
                                >
                                    <button
                                        className="btn btn-icon btn-outline-dark"
                                        onClick={() => {
                                            Swal.fire({
                                                title: `Deseja excluir esse Atendimento? <br/> <br/> Caso: ${row.ID_CASO}`,
                                                icon: "info",
                                                buttonsStyling: false,
                                                confirmButtonText:
                                                    "<i class='la la-check'></i> Sim!",
                                                showCancelButton: true,
                                                cancelButtonText:
                                                    "<i class='la la-thumbs-down'></i> Não",
                                                customClass: {
                                                    confirmButton:
                                                        "btn btn-outline-success",
                                                    cancelButton: "btn btn-default",
                                                },
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    ExcluirAtendimentoController(
                                                        row.ID_CASO,
                                                        UserInfor.ID_USUARIO ?? 0
                                                    ).then(() => {
                                                        updateAtendimentos(
                                                            1,
                                                            atendimento
                                                        );
                                                    });
                                                }
                                            });
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                </OverlayTrigger>
                            )}
                    </div>
                ),
            },
        ];

    return {
        PageFilter,
        filter,
        setPageFilter,
        setPage,
        setFilter,
        idEmpreendimentoOption,
        setIdEmpreendimentoOption,
        idUnidadeOption,
        setIdUnidadeOption,
        valueEtapa,
        setValueEtapa,
        idTipoPeso,
        setIdTipoPeso,
        atendimentosVistoria,
        atendimentosVistoriaLoading,
        updateAtendimentos,
        show,
        setShow,
        modal,
        totalPaginas,
        pesquisaText,
        setPesquisaText,
        handleSearch,
        tableviewColumns,
        filterStorage
    };
}
